import moment from 'moment'
export const downloadFile = (fileBlob, params, apiClassName) => {
  const url = window.URL.createObjectURL(new Blob([fileBlob]));
  const link = document.createElement('a');
  link.href = url;
  if(apiClassName ==='campaigns'){
    const { id, name: nameRaw } = params;
    const name = nameRaw.toLowerCase();
    link.setAttribute('download', `${id}-${name.replace(/\s/g, '-')}-export-campaign.xlsx`);
  }
  else if(apiClassName ==='details') {
    link.setAttribute('download', `exported-usage-details.xls`);
  }
  else {
    const day = moment().format('MMDDYYYY');
    link.setAttribute('download', `exported-contacts-${day}.xlsx`);
  }
  document.body.appendChild(link);
  link.click();
  link.remove();
};
